import gql from 'graphql-tag';

export const GET_REGIONS = gql`
  query {
    regions {
      id
      name
    }
  }
`;

export const GET_REGION = gql`
  query Region($regionId: ID!) {
    region(regionId: $regionId) {
      id
      name
    }
  }
`;

export const GET_CLUBS = gql`
  query Clubs($regionId: ID!) {
    clubs(regionId: $regionId) {
      id
      name
    }
  }
`;

export const GET_CLUB = gql`
  query Club($clubId: ID!) {
    club(clubId: $clubId) {
      id
      name
    }
  }
`;

export const GET_STARTERPACKS = gql`
  query Starterpacks($clubId: ID!) {
    starterpacks(clubId: $clubId) {
      id
      externalStarterPackId
      active
      ospAvailable
      dspAvailable
      isDefault
      priority
      price
      title
    }
  }
`;

export const GET_CLUB_LANGUAGES = gql`
  query ClubLanguages($clubId: ID!) {
    clubLanguages(clubId: $clubId) {
      id
      code
      name
    }
  }
`;

export const GET_STARTERPACK_DATA = gql`
  query Starterpack($externalStarterPackId: ID!, $clubId: ID!, $regionId: ID!) {
    starterpack(externalStarterPackId: $externalStarterPackId, clubId: $clubId) {
      id
      externalStarterPackId
      active
      ospAvailable
      dspAvailable
      isDefault
      priority
      texts {
        id
        title
        description
        language {
          id
          code
          name
        }
      }
    }
    club(clubId: $clubId) {
      id
      name
    }
    region(regionId: $regionId) {
      id
      name
    }
  }
`;

export const UPDATE_STARTERPACK = gql`
  mutation Starterpack($data: UpdateStarterpackInput!, $clubId: ID!) {
    updateStarterpack(data: $data, clubId: $clubId) {
      id
      externalStarterPackId
      active
      priority
      texts {
        id
        title
        description
        language {
          id
          code
          name
        }
      }
    }
  }
`;



// WEBPACK FOOTER //
// ./src/pages/StarterpacksPage/graphql/index.ts